import React, { useState, useEffect } from 'react'
import { useForm, SubmitHandler } from 'react-hook-form'
import { post } from '~/utils/api'
import {
  ModalBody,
  ModalFooterInForm,
  ModalHeader,
  ModalWrapper,
} from '~/components/common/Modal'
import { FormattedMessage } from '~/translations/utils'
import NewClient from '../tickets/list/addTicket/NewClient'
import { useHistory } from 'react-router-dom'

type FormValues = {
  name: string
  nip: string
  phone: string
  email: string
  address: string
  contactName: string
  contactPhone: string
  contactEmail: string
}

const AddClient: React.FC = ({}) => {
  const [openModal, setOpenModal] = useState<Boolean>(false)
  const history = useHistory()

  useEffect(() => {
    document.addEventListener('resetClientForm', e => {
      reset()
    })
  }, [])

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setError,
    reset,
    clearErrors,
  } = useForm<FormValues>()

  const close = () => {
    reset()
    clearErrors()
    setOpenModal(false)
  }

  const onSubmit: SubmitHandler<FormValues> = async data => {
    const res: any = await post(`clients/add`, {
      ...data,
    })

    if (res.error) {
      res.error.nippesel && setError('nip', { message: res.error.nippesel })
      res.error.phone && setError('phone', { message: res.error.phone })
      res.error.name && setError('name', { message: res.error.name })
      res.error.email && setError('email', { message: res.error.email })
      res.error.contact.phone &&
        setError('contactPhone', { message: res.error.contact.phone })
      res.error.contact.name &&
        setError('contactName', { message: res.error.contact.name })
      res.error.contact.email &&
        setError('contactEmail', { message: res.error.contact.email })
    }

    if (res.id) {
      setOpenModal(false)
      reset()
      history.push('/clients/' + res.id)
    }
  }

  return (
    <>
      {Object.keys(errors).length > 0 && console.log(errors)}
      <div>
        <p className="control">
          <button
            className="button is-success is-small"
            type="button"
            onClick={() => {
              clearErrors()
              setOpenModal(true)
            }}
            title={intl.formatMessage({ id: 'client / add' })}
          >
            <FormattedMessage id="client / add" />
          </button>
        </p>
      </div>
      {openModal && (
        <ModalWrapper>
          <form className="modal-card" onSubmit={handleSubmit(onSubmit)}>
            <ModalHeader
              title={intl.formatMessage({
                id: 'client / add',
              })}
              onClose={close}
            />
            <ModalBody>
              <NewClient tab={'new'} control={control} address={true} />
            </ModalBody>
            <ModalFooterInForm onCancel={close} isSubmitting={isSubmitting} />
          </form>
        </ModalWrapper>
      )}
    </>
  )
}

export default AddClient
